import { render, staticRenderFns } from "./courseCategory.vue?vue&type=template&id=191437fe&scoped=true"
import script from "./courseCategory.vue?vue&type=script&lang=js"
export * from "./courseCategory.vue?vue&type=script&lang=js"
import style0 from "./courseCategory.vue?vue&type=style&index=0&id=191437fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191437fe",
  null
  
)

export default component.exports